<template>
  <ion-img
    :class="chatPicClass ? 'chatpic' : 'profilepic'"
    :src="imgUrl"
    alt="profilePic"
  />
</template>

<script>
import { IonImg } from "@ionic/vue";
import { defineComponent } from "vue";
import network from "../../network";

export default defineComponent({
  name: "ProfilePicture",
  components: {
    IonImg,
  },
  props: ["id", "isChat"],
  computed: {
    chatPicClass() {
      return this.isChat === true;
    },
  },
  async mounted() {
    try {
      this.imgUrl = await network.getPhotoURL(this.id);
    } catch (err) {
      console.log("Load Profile Image Error: " + err);
    }
  },
  data() {
    return {
      imgUrl:
        "https://upload.wikimedia.org/wikipedia/commons/4/47/PNG_transparency_demonstration_1.png",
    };
  },
  methods: {},
});
</script>
<style scoped>
.profilepic {
  width: 200px;
  height: 200px;
  position: relative;
  overflow: hidden;
  border-radius: 20%;
}

.chatpic {
  width: 30px;
  height: 30px;
  position: relative;
  overflow: hidden;
  border-radius: 50%;
}

.infotext {
  font-size: 13px;
}
</style>
